import type { TranslateService } from '@ngx-translate/core'

import type { DataModelStore } from './data-model.store'

/**
 * Singular display label of an entity type: an i18n override
 * (`admin.entity_detail.type_singular.<slug>`) when the current locale
 * translates it, else the datamodel's own stored name, else the slug itself.
 *
 * One resolution shared by every "(Type)" parenthetical a lineage renders —
 * the entity page's relation picker, the users-and-groups entity access
 * table, the Learning correction screens — so the same slug can never
 * resolve two different ways depending which screen asks. Takes the two
 * services explicit rather than injecting them itself, so it stays a plain
 * function callable as a `TypeLabelFn` (`entity-option-lineage.ts`) from
 * each component's own constructor: `(slug) => entityTypeLabel(slug,
 * this.dataModelStore, this.translate)`.
 */
export const entityTypeLabel = (
  slug: string,
  dataModelStore: DataModelStore,
  translate: TranslateService
): string => {
  const key = `admin.entity_detail.type_singular.${slug}`
  const translated = translate.instant(key)
  if (translated !== key) return translated
  return dataModelStore.getType(slug)?.name ?? slug
}
